module.exports = __webpack_public_path__ + "img/garuda.560d5a0d.svg";